import { createAction, props } from '@ngrx/store';
import { ConnectionDetails } from './ipsec-statistics.interface';

export const setIpsecStatisticsAction = createAction(
  '[Ipsec statistics] set',
  props<{ ipsec_statistics: ConnectionDetails[] }>()
);

export const clearIpsecStatisticsAction = createAction('[Ipsec statistics] clear');
